import * as React from 'react';
import { Button as ShadcnButton } from '@/components/shadcn-ui/button';
import { cn } from '@/utils/shadcn-ui';

type ShadcnButtonProps = React.ComponentProps<typeof ShadcnButton>;

export function Button({ className, ...props }: ShadcnButtonProps) {
  return (
    <ShadcnButton className={cn('cursor-pointer', className)} {...props} />
  );
}

export default Button;
